<script setup>
import { computed } from 'vue';
import BodyBuildSectionDW5 from './BodyBuildSectionDW5';

import { useMainStore } from '@/store/index.js';
const store = useMainStore();

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  images: {
    type: Object,
    required: true,
  },
  offerTemplate: {
    type: String,
    default: '',
    required: true,
  },
  specType: {
    type: String,
    default: '',
    required: true,
  },
  isFrameAgreement: {
    type: Boolean,
    default: false,
    required: true,
  },
  chassisDescriptionKey: {
    type: String,
    required: false,
    default: '',
  },
  isBev: {
    type: Boolean,
    default: false,
  },
  isRigid: {
    type: Boolean,
    default: false,
  },
  showDimensionsSubheader: {
    type: Boolean,
    default: true,
  },
});

const isSpecEB = computed(() => {
  return props.offerTemplate === `${String(store.market).toUpperCase()}_STANDARDA4X2EB`;
});

const checkIfBodyBuildSectionFrameAgreement = computed(() => {
  return props.isFrameAgreement;
});

const checkIfBodyBuildSectionStockVehicle = computed(() => {
  return props.specType === 'stock_vehicle';
});

const checkIfBodyBuildSectionStandard = computed(() => {
  return props.specType !== 'stock_vehicle' && !props.isBev && (!props.isDW5 && !props.isDW5V2);
});

const checkIfBodyBuildSectionStandardBev = computed(() => {
  return props.isBev && (!props.isDW5 && !props.isDW5V2);
});

const checkIfBodyBuildSectionRigid = computed(() => {
  return props.isRigid;
});
</script>

<template>
  <BodyBuildSectionDW5
    v-if="checkIfBodyBuildSectionRigid"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
    :chassis-description-key="props.chassisDescriptionKey"
    :show-dimensions-subheader="props.showDimensionsSubheader"
  />
</template>

<style scoped>
</style>
